import {
  createStudioLibraryAssistant,
  type StudioLibraryAssistant,
} from './studio-library-assistant'
import { createStudioLibraryRagPlatformCoordinator } from './studio-library-rag-platform-coordinator'

let singleton: StudioLibraryAssistant | null = null

/**
 * The single production Library assistant used by both Chat and Bot tool
 * registration. Construction is lazy and side-effect free: authentication and
 * platform traffic begin only when the shared MCP tool is invoked.
 */
export function resolveStudioLibraryAssistant(): StudioLibraryAssistant {
  if (!singleton) {
    const coordinator = createStudioLibraryRagPlatformCoordinator()
    singleton = createStudioLibraryAssistant({
      orchestrate: (request) => coordinator.orchestrate(request),
    })
  }
  return singleton
}
